//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


const REGEXP_NUMBER = /^-?(?:\d+|\d+\.\d+|\.\d+)(?:[eE][-+]?\d+)?$/;

export default {
    name: "QfPaddingMarginSizeStep",
    props: {
        vertical: { type: Boolean, default: false },
        index: { type: Number, default: -1 },
        value: { type: Number, default: 0 },
        min: { type: Number, default: -99 }
    },
    data() {
        return {
            val: 0,
            oldValue: 0,
            minValue: this.min,
            maxValue: 999,
            inputAttrs: {
                type: "number",
                autocomplete: "off"
            }
        };
    },
    watch: {
        value: {
            handler(val) {
                this.setValue(val, false);
            },
            immediate: true
        }
    },
    methods: {
        setValue(newValue, emit = true) {
            this.val = Math.min(this.maxValue, Math.max(this.minValue, newValue));
            this.oldValue = this.val;

            if (emit) {
                this.$emit("input", this.val);
            }
        },
        onKeyDown(event) {
            const key = event.keyCode || event.which;
            const capturedKeys = [27, 38, 40];

            if (!capturedKeys.includes(key)) { return; }

            if (key === 38 || key === 40) {
                const { shiftKey } = event;
                const newValue = (key === 38) ? this.val + (shiftKey ? 10 : 1) : this.val - (shiftKey ? 10 : 1);

                this.setValue(newValue);
            } else if (key === 27) {
                this.setValue(this.oldValue);
            }

            event.preventDefault();
        },
        onPaste(event) {
            const clipboardData = event.clipboardData || window.clipboardData;

            if (clipboardData && !REGEXP_NUMBER.test(clipboardData.getData("text"))) {
                event.preventDefault();
            }
        },
        onInputUpdate(event) {
            const { value } = event.target;

            this.setValue(parseInt(value || 0, 10));
        },
        repeatDec({ evt: event }) {
            if (this.val > this.minValue) {
                const step = event.shiftKey ? 10 : 1;
                const newValue = this.val - step;

                this.setValue(newValue);
            }
        },
        repeatInc({ evt: event }) {
            if (this.val < this.maxValue) {
                const step = event.shiftKey ? 10 : 1;
                const newValue = this.val + step;

                this.setValue(newValue);
            }
        }
    }
};
